import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';
import AdminReviewList from '../components/AdminReviewList';

const AdminReviews = () => {
    return (
        <ProtectedRoute roles={['ADMIN']}>
            <DashboardLayout title="Review Management" roles={['ADMIN']}>
                <AdminReviewList />
            </DashboardLayout>
        </ProtectedRoute>
    );
};

export default AdminReviews;
